export enum MessageAddresses {
  All = 'all',
  Partial = 'partial',
  User = 'user'
}

export enum MessagePartialConditions {
  ReturningUsers = 'returning-users',
  NewUsers = 'new-users',
  ByTag = 'by-tag',
  HasAppointmentInRange = 'appointment-in-range',
  LoyaltyProgram = 'loyalty-program',
  ByProvider = 'by-provider',
}

export interface ISmsClientsFilter {
  customersBase: MessageAddresses;
  condition?: MessagePartialConditions;
  dateRange?: {
    start: string;
    end: string;
  },
  arg?: string;
}
